// Compact one-liner showing the frozen driver strings captured at the
// moment this decision was generated. Extracted from DecisionEnginePage.js
// during Phase 1 consolidation — no logic or visual changes.
import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const RiskSnapshotInline = ({ snapshot, evolution }) => {
  const s = snapshot || {};
  const injury = Array.isArray(s.injury) ? s.injury : [];
  const fatigue = Array.isArray(s.fatigue) ? s.fatigue : [];
  const load = Array.isArray(s.load) ? s.load : [];
  if (!injury.length && !fatigue.length && !load.length) return null;

  const parts = [];
  if (injury.length) parts.push(['Injury', injury.join(', ')]);
  if (fatigue.length) parts.push(['Fatigue', fatigue.join(', ')]);
  if (load.length) parts.push(['Load', load.join(', ')]);

  const hasEvolution =
    evolution && (
      Number.isFinite(evolution.active_count) ||
      Number.isFinite(evolution.resolved_count)
    );

  return (
    <div
      className="flex items-center gap-2 text-[11px] text-amber-700 dark:text-amber-300 px-1 truncate"
      data-testid="risk-snapshot-inline"
      aria-label="Historical risk drivers at decision time"
      title={parts.map(([k, v]) => `${k} → ${v}`).join('  ·  ')}
    >
      <AlertTriangle className="h-3 w-3 shrink-0" />
      <span className="font-medium shrink-0">At decision time:</span>
      <span className="truncate text-gray-600 dark:text-gray-400">
        {parts.map(([k, v], i) => (
          <span key={k} data-testid={`risk-snapshot-${k.toLowerCase()}`}>
            {i > 0 && <span className="text-gray-400 mx-1.5">·</span>}
            <span className="font-semibold text-amber-700 dark:text-amber-300">{k}</span>
            <span className="text-gray-500 mx-1">→</span>
            <span>{v}</span>
          </span>
        ))}
      </span>
      {hasEvolution && (
        <span
          className="ml-auto shrink-0 inline-flex items-center gap-1 text-[10px] font-medium"
          data-testid="risk-evolution-indicator"
        >
          <span className="text-amber-700 dark:text-amber-400" data-testid="risk-evolution-active">
            {evolution.active_count || 0} active
          </span>
          <span className="text-gray-400">·</span>
          <span className="text-emerald-600 dark:text-emerald-400" data-testid="risk-evolution-resolved">
            {evolution.resolved_count || 0} resolved
          </span>
          {evolution.resolved_count > 0 && evolution.since && (
            <>
              <span className="text-gray-400">·</span>
              <span
                className="text-gray-500 dark:text-gray-400 font-normal"
                data-testid="risk-evolution-since"
              >
                since {evolution.since}
              </span>
            </>
          )}
        </span>
      )}
    </div>
  );
};
